import { render, staticRenderFns } from "./EventoScheduling.vue?vue&type=template&id=63b5b6ec"
import script from "./EventoScheduling.vue?vue&type=script&setup=true&lang=js"
export * from "./EventoScheduling.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports